/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/aria-role */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ActionPanel from '../../../components/Controller/ActionPanel';
import SizeTab from '../../../components/ViewerWindow/SizeTab';
import {
  sizeData,
  skuVariantMap,
  tshirtSizeData
} from '../../../utils/staticData';
import ButtonPrimary from '../../../components/common/ButtonPrimary';
import PopupOverlay from '../../../components/common/PopupOverlay';
import { useLocation } from 'react-router-dom';
import TermsAndConditions from '../../../components/common/TermsAndConditions';

const sizeCharts = {
  // helmets
  HelmetOpenFace:
    'https://reecommprod.blob.core.windows.net/re-assets/images/helmet-new.jpg',
  HelmetFullFace:
    'https://reecommprod.blob.core.windows.net/re-assets/images/helmet-new.jpg',
  HelmetUrbanTrooper:
    'https://reecommprod.blob.core.windows.net/re-assets/images/helmet-new.jpg',

  // Tshirt
  TShirt:
    'https://reecommprod.blob.core.windows.net/re-assets/images/tshirtsize.jpg',

  // jacket
  windfarer:
    'https://reecommprod.blob.core.windows.net/re-assets/images/Windfarer.jpg',
  streetwindV2:
    'https://reecommprod.blob.core.windows.net/re-assets/images/streetwind.jpg',
  explorerV3:
    'https://reecommprod.blob.core.windows.net/re-assets/images/Explore.jpg',
  stormRaider:
    'https://reecommprod.blob.core.windows.net/re-assets/images/StormRaider.jpg',
  khardungLaV2:
    'https://reecommprod.blob.core.windows.net/re-assets/images/KhardunglaV2.jpg',
  nirvik:
    'https://reecommprod.blob.core.windows.net/re-assets/images/Nirvik_A.jpg'
};

// previously we used to send only sizeData, where sizes are hardcoded from the list, use this func to show only available sizes
const getOnlyExistingSizeData = (partsConfig, selectedVariant) => {
  const currVisorPart = partsConfig.visor
    ? Object.keys(partsConfig.visor).find(x => partsConfig.visor[x] === true)
    : 'normal';

  return sizeData.filter(it => {
    if (skuVariantMap[selectedVariant][currVisorPart][it.value]) {
      return true;
    }
    return false;
  });
};

const SizeSelector = ({
  isOpen,
  selectedSize,
  setSnackbar,
  onCloseButtonClick,
  onGuideSizeButtonClick,
  setSelectedSize,
  onAddToCartClick,
  selectedVariant,
  partsConfig
}) => {
  console.log(selectedVariant, "XXXXX")
  const [showSizeGuide, setShowSizeGuide] = useState(false);
  const location = useLocation();
  return (
    <PopupOverlay isOpen={isOpen} onOverlayClick={onCloseButtonClick}>
      <ActionPanel
        isCloseButtonHidden={false}
        label={`select your ${
          location.pathname.includes('tshirt')
            ? 'T-Shirt'
            : location.pathname.includes('jackets')
            ? 'Jacket'
            : 'Helmet'
        } size`}
        onCloseButtonClick={onCloseButtonClick}
      >
        {showSizeGuide && (
          <div
            width="56px"
            height="56px"
            style={{
              position: 'absolute',
              top: '20px',
              left: '20px',
              cursor: 'pointer'
            }}
            onClick={() => setShowSizeGuide(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              width="24"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42-.39-.39-1.02-.39-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z" />
            </svg>
          </div>
        )}
        {!showSizeGuide && (
          <div className="size-selector_container">
            <SizeTab
              sizes={
                location.pathname.includes('tshirt') ||
                location.pathname.includes('jackets')
                  ? tshirtSizeData
                  : getOnlyExistingSizeData(partsConfig, selectedVariant)
              }
              onChange={i => {
                setSelectedSize(
                  location.pathname.includes('tshirt') ||
                    location.pathname.includes('jackets')
                    ? tshirtSizeData[i].value
                    : sizeData[i].value
                );
              }}
            />
            <div
              role="presentation"
              onClick={() => setShowSizeGuide(true)}
              className="size-selector_btm-txt"
            >
              size guide
            </div>
            <div className="size-selector_buttonwrap">
              <ButtonPrimary
                onClick={
                  selectedSize === ''
                    ? () => {
                        setSnackbar({ isOpen: true, text: 'Select Size !' });
                      }
                    : onAddToCartClick
                }
                label="add to cart"
              />
            </div>
            <TermsAndConditions />
          </div>
        )}
        {showSizeGuide && (
          <img
            alt="size guide"
            style={{
              objectFit: 'contain'
            }}
            src={sizeCharts[selectedVariant]}
            width="100%"
            height="100%"
          />
        )}
      </ActionPanel>
    </PopupOverlay>
  );
};

SizeSelector.propTypes = {
  isOpen: PropTypes.bool,
  onCloseButtonClick: PropTypes.func,
  onGuideSizeButtonClick: PropTypes.func,
  setSelectedSize: PropTypes.func
};

export default SizeSelector;
